import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderComponent } from '../../../../common-component/loader/loader.component';
import { UserActivityServiceService } from '../../../../services/raintree/Transmission/user-activity-service.service';
import { ToastrService } from 'ngx-toastr';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { DepositReportFilterComponent } from './deposit-report-filter/deposit-report-filter.component';
import { log } from 'console';

enum ReportTypes {
  GLOBAL = 'ALL',
  COUNTRIES = 'COUNTRIES',
  STATES = 'STATES',
  DISTRICTS = 'DISTRICTS',
}
@Component({
  selector: 'app-iv-deposit-report',
  standalone: true,
  imports: [LoaderComponent, ReactiveFormsModule, MatSelectModule, CommonModule],
  templateUrl: './iv-deposit-report.component.html',
  styleUrl: './iv-deposit-report.component.scss'
})
export class IvDepositReportComponent implements OnInit {

  showReportType: string = '';
  depositReport: any[] = [];
  isMobile: boolean = false;
  isLoading: boolean = false;
  pincode = new FormControl('');
  stateList: any = [];
  districtList: any = [];
  state = new FormControl('');
  district = new FormControl('');
  pincodeList: any = [];
  searchReq = new FormControl('');
  tempData: any[] = [];

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private userService: UserActivityServiceService,
    private toaster: ToastrService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.isMobile = window.matchMedia('(max-width: 600px)').matches
    console.log(this.isMobile);
     this.searchReq.valueChanges.subscribe((value: any) => {
      this.depositReport = this.tempData;
      if (value?.length > 0) this.onSearch(value);

    });
    
    this.onCountryClick('INDIA')
    this.subscribeToRouteParams()

  }

  onSearch(value: any){
    this.depositReport = this.filterData(
      this.depositReport,
      value
    )
  }

   filterData(data: any[], searchTerm: string) {
    searchTerm = searchTerm.toLowerCase();
    return data.filter((item) => {
       return Object.values(item)?.toString().toLowerCase().includes(searchTerm);
      });
  }

  onStateSelect(state: any) {
    this.districtList = Object.keys(this.pincodeList?.[state.value])
    if (this.districtList.length == 1) {
      this.onDistrictClick(this.districtList[0], state.value)
    }
  }

  onDistrictSelect(district: any) {
    if (this.stateList.length === 1) this.onDistrictClick(district.value, this.stateList[0])
    else this.onDistrictClick(district.value, this.state.value)

  }

  subscribeToRouteParams() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['state'] && params['district']) {
        this.showReportType = ReportTypes.DISTRICTS
        this.FetchDepositReportDetails({ state: params['state'], district: params['district'] })

      } else if (params['state']) {
        this.showReportType = ReportTypes.STATES
        this.FetchDepositReportDetails({ state: params['state'] })

      } else if (params['country']) {
        this.showReportType = ReportTypes.COUNTRIES
        this.FetchDepositReportDetails({})
      } else if (!params['country']) {
        this.onCountryClick('INDIA')
        this.showReportType = ReportTypes.COUNTRIES
        // this.FetchDepositReportDetails({cummulative: true})
      }
    })
  }

  FetchDepositReportDetails(queryparams: any) {
    this.userService.fetchIvDepositReport(queryparams).subscribe({
      next: (res) => {
        if (this.pincode?.value && this.showReportType === 'DISTRICTS') {
          this.depositReport = this.tempData = res.data.filter((item: any) => item?.pincode === this.pincode.value)
          
        } else {
          this.depositReport = this.tempData = res.data
        }
      },
      error: (err) => {
        this.depositReport = this.tempData = []
        this.toaster.error(err.message)
      }
    })
  }


  onCountryClick(item: any) {
    this.showReportType = ReportTypes.COUNTRIES
    this.router.navigate([`${this.router.url}`], {
      queryParams: {
        country: item,
      },

    })
  }

  onStateClick(state: any) {
    let qparams: any;
    this.showReportType = ReportTypes.STATES

    this.activatedRoute.queryParams.subscribe((params) => {
      qparams = Object.assign({}, params);
    });
    qparams.state = state
    this.router.navigate([`${this.router.url.split('?')[0]}`], {
      queryParams: qparams,
    });
  }

  onDistrictClick(district: any, state?: any) {

    let qparams: any;
    this.showReportType = ReportTypes.DISTRICTS
    this.activatedRoute.queryParams.subscribe((params) => {
      qparams = Object.assign({}, params);
    });
    if (this.pincode?.value) qparams.state = state
    qparams.district = district
    this.router.navigate([`${this.router.url.split('?')[0]}`], {
      queryParams: qparams,
    });
  }

  onFilterClick() {
    const dialogRef = this.dialog.open(DepositReportFilterComponent, {
      data: {
        state: this.state.value,
        district: this.district.value,
        pin: this.pincode.value
      }
    })

    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res) {
          console.log(res);
          
          this.state.setValue(res.state)
          this.district.setValue(res.district)
          this.pincode.setValue(res.pin)
          this.onDistrictClick(res.district, res.state);
        }
      }
    })
  }


}
